// extracted by mini-css-extract-plugin
export default {"root":"AboutPrice_root__azw8Z","title":"AboutPrice_title__pErJg"};